var _desc, _defs, _g, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 420 420",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "ePathshala") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "description"
  }, "A navy and gold school checklist logo")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gold",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc14d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f59e0b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "navy",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#292481"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#15125f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 102 86 296c-3 25 11 41 36 41h178l14-115",
    stroke: "url(#navy)",
    strokeWidth: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129 91h196c16 0 25 12 22 29l-25 139M129 91 101 309",
    stroke: "url(#gold)",
    strokeWidth: 14
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52 141h49M36 203h56M22 267h61",
    stroke: "url(#gold)",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 84c49-17 76 4 67 53-14 78-98 161-202 198-63 23-108 13-105-28",
    stroke: "url(#navy)",
    strokeWidth: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165 70 169 39c1-10 9-17 18-17s15 7 14 17l-4 31c-1 10-9 17-18 17s-15-7-14-17Zm53 0 4-31c1-10 9-17 18-17s15 7 14 17l-4 31c-1 10-9 17-18 17s-15-7-14-17Zm53 0 4-31c1-10 9-17 18-17s15 7 14 17l-4 31c-1 10-9 17-18 17s-15-7-14-17Z",
    stroke: "url(#navy)",
    strokeWidth: 11
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "url(#navy)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 145,
    y: 132,
    width: 35,
    height: 35,
    rx: 6,
    fill: "url(#navy)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m153 148 8 9 17-20",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197 143h81",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139,
    y: 184,
    width: 35,
    height: 35,
    rx: 6,
    fill: "url(#navy)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m147 200 8 9 17-20",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191 195h75",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132,
    y: 236,
    width: 35,
    height: 35,
    rx: 6,
    fill: "url(#navy)",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140 252 8 9 17-20",
    stroke: "#fff",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 247h66",
    strokeWidth: 8
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 210,
    y: 397,
    fill: "#17146d",
    fontFamily: "Arial Rounded MT Bold, Trebuchet MS, sans-serif",
    fontSize: 43,
    fontWeight: 700,
    letterSpacing: 1,
    textAnchor: "middle"
  }, "ePathshala")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.972a1c1e4229fb86545317702e1e2928.svg";
export { ForwardRef as ReactComponent };